import React, { useState, useEffect, useRef } from "react";
import LocationCode from "../../../utils/constants/LocationCode";

let UserListLocationSelector = (props) => {
    let [isOpen, setIsOpen] = useState(false)
    let ref = useRef(null)

    const handleClickOutSide = (e) => {
        if (!ref.current.contains(e.target)) {
            setIsOpen(false)
        }
    }

    useEffect(() => {
        if (isOpen) document.addEventListener('mousedown', handleClickOutSide)
        return () => {
            document.removeEventListener('mousedown', handleClickOutSide)
        }
    }, [isOpen])
    return (
        <div className="user-list-header-tag user-list-location-dropdown-position"  onClick={() => setIsOpen(!isOpen)}>
            <div className="user-list-location">
                <p>
                    {props.locationToList === LocationCode.NOT_LOADING ?
                        "전체" : LocationCode.text[props.locationToList]}
                </p>
                <div className="location-selector-button"></div>
            </div>
            <div className="user-list-location-dropdown-area-wrapper" ref={ref}>
                {isOpen ?
                    <div className="user-list-location-dropdown-area" onClick={() => setIsOpen(false)}>
                        <div className="user-list-location-dropdown-box"></div>
                        {LocationCode.text.map((location, index) => {
                            return (
                                <div className="user-list-location-dropdown-box" key={location}>
                                    <p className="user-list-location-dropdown-text" onClick={() => props.onLocationToListChange(index)}>{location}</p>
                                </div>
                            )
                        })}
                        <div className="user-list-location-dropdown-box">
                            <p className="user-list-location-dropdown-text" onClick={() => props.onLocationToListChange(LocationCode.NOT_LOADING)}>전체</p>
                        </div>
                    </div> : null}
            </div>
        </div>
    )
}

export default UserListLocationSelector